<template>
  <div class="layout outer-layout">
    <router-view/>
    <div
      id="loader"
      class="page-loader">
      <div class="loading-circle"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OuterLayout',
};
</script>
